import {
  GTBusinessCustomerSuggestion,
  GTBusinessCustomerTypeInput,
  GTBusinessCustomerUserAccount
} from 'gql/types.generated'

export interface IBusinessCustomersFiltersForm {
  status: string
  phone: string
  email: string
  userId: string
  customerId: string
  category: string
  businessCustomers: GTBusinessCustomerSuggestion[]
  site: {
    id: string
    name: string
  }
  client: {
    id: string
    name: string
  }
}

export interface IBusinessCustomerFormValues {
  userAccountId?: string
  kreditsSettings: {
    amount: string
    category: string
  }
  firstName?: string
  lastName?: string
  phoneNumber: {
    number?: string
    countryCode?: string
  }
  email?: string
  customerType: GTBusinessCustomerTypeInput
  placeAddress: {
    street: string
    zipCode: string
    cityName: string
    cityId: string
    location: {
      latitude: string
      longitude: string
    }
  }
  businessSite: {
    id: string
    name: string
  }
  businessClient: {
    id: string
    name: string
    verticals: string[]
  }
}

export interface IBusinessCustomerCSVFormValues {
  file?: string | File
  filePath: string
  businessClient: {
    id: string
    name: string
  }
  businessSite: {
    id: string
    name: string
  }
  customerType: string
}

export enum EBusinessCustomerStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export interface IBusinessCustomerUserAccountPDFData extends GTBusinessCustomerUserAccount {
  qrCode: string
  qrImageBase64: string
}

export interface IEditBusinessCustomerPlaceFormValues {
  street: string
  zipCode: string
  city: {
    id: string
    name: string
  }
  location: {
    latitude: string
    longitude: string
  }
}
